/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Debug_Logging_PlaceholderInputs */

const en_drastic_tech_debug_logging_placeholder = /** @type {(inputs: Drastic_Tech_Debug_Logging_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Console logging will appear here to help when debugging`)
};

const fr_drastic_tech_debug_logging_placeholder = /** @type {(inputs: Drastic_Tech_Debug_Logging_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les journaux de console apparaitront ici pour aider au debogage`)
};

const de_drastic_tech_debug_logging_placeholder = /** @type {(inputs: Drastic_Tech_Debug_Logging_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Konsolenprotokolle werden hier angezeigt, um beim Debuggen zu helfen.`)
};

const it_drastic_tech_debug_logging_placeholder = /** @type {(inputs: Drastic_Tech_Debug_Logging_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La registrazione della console apparirà qui per aiutare durante il debug`)
};

const ru_drastic_tech_debug_logging_placeholder = /** @type {(inputs: Drastic_Tech_Debug_Logging_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Здесь будут отображаться сообщения в консоли, которые помогут при отладке.`)
};

const es_drastic_tech_debug_logging_placeholder = /** @type {(inputs: Drastic_Tech_Debug_Logging_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El registro de la consola aparecerá aquí para ayudar durante la depuración.`)
};

const zh_cn2_drastic_tech_debug_logging_placeholder = /** @type {(inputs: Drastic_Tech_Debug_Logging_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`控制台日志将显示在此处，以帮助调试。`)
};

const ja_drastic_tech_debug_logging_placeholder = /** @type {(inputs: Drastic_Tech_Debug_Logging_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバッグ時に役立つコンソールログがここに表示されます`)
};

const hi_drastic_tech_debug_logging_placeholder = /** @type {(inputs: Drastic_Tech_Debug_Logging_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डीबगिंग में सहायता के लिए कंसोल लॉगिंग यहां दिखाई देगी।`)
};

const pt_pt2_drastic_tech_debug_logging_placeholder = /** @type {(inputs: Drastic_Tech_Debug_Logging_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O registro do console aparecerá aqui para auxiliar na depuração.`)
};

/**
* | output |
* | --- |
* | "Console logging will appear here to help when debugging" |
*
* @param {Drastic_Tech_Debug_Logging_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_debug_logging_placeholder = /** @type {((inputs?: Drastic_Tech_Debug_Logging_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Debug_Logging_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_drastic_tech_debug_logging_placeholder(inputs)
	if (locale === "de") return de_drastic_tech_debug_logging_placeholder(inputs)
	if (locale === "it") return it_drastic_tech_debug_logging_placeholder(inputs)
	if (locale === "ru") return ru_drastic_tech_debug_logging_placeholder(inputs)
	if (locale === "es") return es_drastic_tech_debug_logging_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_drastic_tech_debug_logging_placeholder(inputs)
	if (locale === "ja") return ja_drastic_tech_debug_logging_placeholder(inputs)
	if (locale === "hi") return hi_drastic_tech_debug_logging_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_drastic_tech_debug_logging_placeholder(inputs)
	return en_drastic_tech_debug_logging_placeholder(inputs)
});